export const getMilliseconds = (timestamp: number): number => {
  return timestamp / 10000
}
